export default __webpack_public_path__ + "static/hero_banner_normal-93bf670d4e3154ab1bab0bd893f3d937.jpg";